
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deities",
      function () {
        return require("private-next-pages/deities/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deities"])
      });
    }
  